namespace Portico.Services {

    import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;
	import pme = Portico.Models.Enterprise;
    import psga = apigateway.client;
    import psgm = apigateway.models;

	export interface ILocationService {
		getCities: (zip: string) => angular.IPromise<pme.City[]>;
        getStates: () => angular.IPromise<pme.State[]>;
        getSuggestedAddress(address: pme.Address): angular.IPromise<pme.IPartialAddress[]>;
    }

    @Service('app', 'locationService')
	@Inject('$q', 'spinnerOverrideService', 'LocationV1Api')
	export class LocationService implements ILocationService {
        constructor(
            private $q: angular.IQService,
			private spinnerOverrideService: ISpinnerOverrideService,
			private locationV1Api: psga.LocationV1Api
        ) { }

		getCities(zip: string): angular.IPromise<pme.City[]> {
			//let cities: pme.City[] = this.storageService.getItem<pme.City[]>(pm.StorageType.Session, `city-${zip}-list`);

			const promise = // cities ?
                // this.$q.when(cities) :
                this.spinnerOverrideService.withoutUntil<psgm.LocationCityModel[]>(() => this.$q.when(this.locationV1Api.getCitiesByZip(zip).then(response => {
                    return response.data.data;
                })));

			return promise.then((response: psgm.LocationCityModel[]) => {
				const temp: pme.City[] = [];

				for (const city of response) {
					temp.push(new pme.City(city));
				}

				//this.storageService.saveItem<pme.City[]>(pm.StorageType.Session, `city-${zip}-list`, temp);

				return temp;
            });
        }

        getSuggestedAddress(address: pme.Address): angular.IPromise<pme.IPartialAddress[]> {
            const searchAddress: psgm.LocationAddressModel = {
                businessName: '',
                line1: address.address1,
                line2: address.address2 || '',
                city: address.city,
                state: address.state,
                postalCode: address.zip
            };

            return this.$q.when(this.locationV1Api.validAddress(searchAddress).then((results) => {
                if (results.data.data.hasMatches) {
                    const returnAddresses: pme.IPartialAddress[] = [];

                    results.data.data.addresses.forEach(a => {
                        const address: pme.IPartialAddress = {
                            address1: a.line1 || '',
                            address2: a.line2 || '',
                            city: a.city || '',
                            state: a.state || '',
                            zip: a.postalCode
                        };

                        returnAddresses.push(address);
                    });

                    return returnAddresses;
                }
                else {
                    return [];
                }
            }));
        }

		getStates(): angular.IPromise<pme.State[]> {
			// let states: pme.State[] = this.storageService.getItem<pme.State[]>(pm.StorageType.Session, `state-list`);

			const promise = // states ?
				// this.$q.when(states) :
                this.$q.when(this.locationV1Api.getAllStates().then(response => {
                    return response.data.data;
                }));

			return promise.then((response: psgm.LocationSharedStateModel[]) => {
				const temp: pme.State[] = [];

				for (let i = 0; i < response.length; i++) {
					const state = response[i];
					const length = state.description.length;

					if (state.description.charAt(length - 1) === '.') {
						state.description = state.description.substring(0, length - 1);
					}

					if (state.description !== 'UNKNOWN') {
						temp.push(new pme.State(state));
					}
                }

				// this.storageService.saveItem<pme.State[]>(pm.StorageType.Session, `state-list`, temp);

				return temp;
            });
        }
    }
}